export default __webpack_public_path__ + "static/Entenda0081-c1a4ba9062d87d606d79318984620b55.jpg";